import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://apnidhanibakery.in';
const SITE_NAME = 'Apni Dhani Bakery';

// Renders a unique <title>, meta description, and self-referencing canonical for the current page.
// path should start with '/' (e.g. '/menu') or be '' for the homepage.
export const SEO = ({ title, description, path = '' }) => {
  const canonicalUrl = `${SITE_URL}${path}`;
  return (
    <Helmet>
      <title>{`${title} | ${SITE_NAME}`}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default SEO;
